import styled from 'styled-components';

export const Container = styled.div`

    display: none;

    @media(max-width: 690px) {
        display: flex;
        position: fixed;
        top: 0;
        width: 100%;
        min-width: 320px;
        height: 129px;
        background-color: #fff;
        -webkit-box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.1);
        -moz-box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.1);
        box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.1);
        align-items: center;
        justify-content: center;
        -webkit-transition: 0.7s;
        transition: 0.7s;
        z-index: 9;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
    }

    .rest-container {
        display: flex;
        flex-direction: row;
        margin-left: 40px;

        .logo {
            display: flex;
            width: 40px !important;
            height: 40px !important;
            .perfil {
                overflow: hidden;
                object-fit: cover;
                width: 100%;
                height: 100%;
                border-radius: 100px;
            }
        }
    }

    .status-container {
        display: flex;
        flex-direction: row;
        margin-right: 40px;
    }

    .miolo {
        display: flex;
        flex-direction: column;
        max-width: 1096px;
        min-width: 360px;
        width: 100%;
        align-items: center;
        justify-content: center;
        -webkit-transition: 0.7s;
        transition: 0.7s;

        .logo {
            height: 40px;
            width: 100%;
            align-items: center;
            justify-content: center;
            display: flex;
            -webkit-transition: 0.7s;
            transition: 0.7s;

            .logocompletovermelho {
                width: 107px;
                height: 32px;
                object-fit: contain;
                -webkit-transition: 0.7s;
                transition: 0.7s;
            }
        }

        hr {
                display: block;
                width: 100%;
                border-top: 2px solid #f3f3f3;
                margin: auto;
                margin-top: 6px;
                margin-bottom: 8px;
            }

        .restaurante {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 56px;

            .perfil {
                overflow: hidden;
                object-fit: cover;
                border-radius: 100px;
                width: 40px;
                height: 40px;
            }

            .texto {
                display: flex;
                flex-direction: column;
                margin-left: 16px;
                justify-content: space-evenly;

                .ola {
                    margin: 0px;
                    font-family: Montserrat;
                    font-size: 14px;
                    color: #a49b9b;
                    font-weight: 400
                }

                .rest {
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    .nome {
                        margin-top: 0px;
                        margin-bottom: 0px;
                        font-family: Montserrat;
                        font-size: 16px;
                        font-weight: 600;
                        color: #2a0709;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 1; /* number of lines to show */
                        -webkit-box-orient: vertical;
                    }

                    button {
                        cursor: pointer;
                        border: none;
                        outline: none;
                        background-color: transparent;
                        padding: 0;
                        margin-left: 16px;

                        .chevron {
                            transition: 0.3s transform;
                            -webkit-transform: ${({ modalOpen }) => modalOpen ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                            transform: ${({ modalOpen }) => modalOpen ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                        }
                    }
                }
            }

            .status-aberto {
                display: flex;
                width: 104px;
                height: 32px;
                border-radius: 50px;
                background-color: #dcead3;
                border: 1.5px solid #4e9721;
                align-items: center;
                justify-content: center;
                margin-left: 40px;

                .statusText {
                    align-self: center;
                    text-align: center;
                    color: #4e9721;
                    font-family: Montserrat;
                    font-size: 9px;
                    font-weight: 800;
                }
            }

            .status-fechado {
                display: flex;
                width: 104px;
                height: 32px;
                border-radius: 50px;
                background-color: #f3d1d4;
                border: 1.5px solid #c32027;
                align-items: center;
                justify-content: center;
                margin-left: 40px;

                .statusText {
                    align-self: center;
                    text-align: center;
                    color: #c32027;
                    font-family: Montserrat;
                    font-size: 9px;
                    font-weight: 800;
                }
            }
        }
    }
`